// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!!!!! Do not modify this file or change will probably be lost !!!!!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import Validator from './Validator';
import MinMaxDTO from './MinMaxDTO';
import CreditTypeDTO from './CreditTypeDTO';
import EntitySelectorDTO from './EntitySelectorDTO';

interface CourseModificationChangeRequestCreditDTO extends EntitySelectorDTO { 
	id: string | null;
	courseModificationChangeRequestId: string | null;
	creditTypeId: string | null;
	minHours: number | null | null;
	maxHours: number | null | null;
	creditType: CreditTypeDTO | null;
}

const CourseModificationChangeRequestCreditDTO = {
    className: 'CourseModificationChangeRequestCreditDTO',
    create: (initValues?: Partial<CourseModificationChangeRequestCreditDTO> | Record<string, unknown> | null) => {
        return Object.assign(EntitySelectorDTO.create(),
        {
			id: '00000000-0000-0000-0000-000000000000',
			courseModificationChangeRequestId: '00000000-0000-0000-0000-000000000000',
			creditTypeId: '00000000-0000-0000-0000-000000000000',
			minHours: null,
			maxHours: null,
			creditType: null,
        },
        initValues);
    },
	id: 'id',
	courseModificationChangeRequestId: 'courseModificationChangeRequestId',
	creditTypeId: 'creditTypeId',
	minHours: 'minHours',
	maxHours: 'maxHours',
	creditType: 'creditType',
};

export default CourseModificationChangeRequestCreditDTO;